import getObjectValue from "libs/getObjectValue";
import { Collapse } from "@material-ui/core";
import NoticeObjectNotDivided from "./NoticeObjectNotDivided";
import NoticeObjectDivided from "./NoticeObjectDivided";

function NoticeObjectData(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const hasMultipleObjects = gVal("noticeHasManyObjects");
    return (
        <>
            <Collapse in={hasMultipleObjects === true}>
                <NoticeObjectDivided id={gId("divided")} formikProps={formikProps} />
            </Collapse>
            <Collapse in={hasMultipleObjects === false}>
                <NoticeObjectNotDivided id={gId("notDivided")} formikProps={formikProps} />
            </Collapse>
        </>
    )
}

NoticeObjectData.propTypes = {};
export default NoticeObjectData;